<div class="module__logo openai-logo">
  <span class="openai-logo__icon"><i class="las la-robot"></i></span>
  <span class="openai-logo__title">OpenAI</span>
</div>

<div class="openai-settings-card">
  <div class="openai-status-row">
    <strong>Status:</strong>
    <span class="openai-status-pill" [ngClass]="{ 'openai-status-pill--ok': configured, 'openai-status-pill--warn': !configured }">
      {{ configured ? 'Geconfigureerd' : 'Niet geconfigureerd' }}
    </span>
  </div>

  <form (ngSubmit)="saveKey()" class="openai-form" autocomplete="off">
    <div class="form-group m-b-2">
      <label for="openaiKey">API-sleutel</label>
      <password-input
        id="openaiKey"
        [placeholder]="'sk-...'"
        [showLabel]="false"
        [name]="'openaiKey'"
        [autocomplete]="'new-password'"
        [(ngModel)]="apiKeyInput"
      >
      </password-input>
    </div>

    <div class="openai-actions d-flex align-items-center m-b-2">
      <button class="button button--small button--primary m-r-2" type="submit" [disabled]="loading">Opslaan</button>
      <button class="button button--small button--outline" type="button" (click)="clearKey()" [disabled]="loading || !configured">Verwijderen</button>
    </div>
  </form>

  <small class="text-muted">Sleutel wordt versleuteld in de backend opgeslagen.</small>

  <div *ngIf="message" class="m-t-2 openai-message">
    <small>{{ message }}</small>
  </div>
</div>

<!-- Model selector -->
<div *ngIf="configured" class="openai-model-section">
  <div class="divider m-t-4 m-b-4"></div>

  <h3 class="m-b-1">Model kiezen</h3>
  <p class="form-helptext m-b-3">Het gekozen model wordt gebruikt voor alle AI-functies (Yuki allocatie, timesheet validatie, etc.). Goedkopere modellen zijn snel en voordelig. Duurdere modellen kunnen beter presteren bij complexe facturen.</p>

  <div *ngIf="loadingModels" class="loading-state">
    <i class="uil uil-spinner-alt spin"></i>
    <span>Modellen laden...</span>
  </div>

  <div *ngIf="!loadingModels && availableModels.length > 0" class="model-list">
    <div
      *ngFor="let model of availableModels"
      (click)="updateModel(model.id)"
      class="model-row"
      [class.model-row--active]="model.id === selectedModel">
      <div class="model-row__radio">
        <span class="radio-dot" [class.radio-dot--selected]="model.id === selectedModel"></span>
      </div>
      <div class="model-row__info">
        <div class="model-row__header">
          <span class="model-row__name">{{ model.id }}</span>
          <span *ngIf="model.recommended" class="badge badge--recommended">Aanbevolen</span>
        </div>
        <div class="model-row__desc">{{ model.description }}</div>
      </div>
      <div class="model-row__price"
           [class.price--low]="model.priceTier.length <= 1"
           [class.price--mid]="model.priceTier.length === 2"
           [class.price--high]="model.priceTier.length === 3"
           [class.price--very-high]="model.priceTier.length >= 4">
        {{ model.priceTier }}
      </div>
    </div>
  </div>

  <div *ngIf="!loadingModels && availableModels.length === 0" class="empty-state">
    <i class="uil uil-exclamation-triangle"></i>
    <span>Geen modellen beschikbaar.</span>
  </div>
</div>
